// extracted by mini-css-extract-plugin
export default {"dialog--background":"BljggYtouGQiSjSmYZamK9QAFhJXJg2OjjfWtqr5UfI="};